import { agregarDatos, editar } from "services/crudFirebase";
import { v4 as uuidv4 } from "uuid";

export const generateKey = (str) => {
    const withoutTilde = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const titleCase = withoutTilde.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    const underscore = titleCase.replace(/ /g, "_").replace(/\/_/g, "");
    return underscore;
};

export const handleSetItem = (newItem, oldItems) => {
    agregarDatos(newItem, "CatalogoFlexores");
    console.log([...oldItems, newItem]);
    return [...oldItems, newItem];
};

const trimStringsInArray = (array, disableInput = false) => {
    // const result = array.map((i) => i.trim());
    const result = array.map((i) => i[1].trim());
    if (!disableInput) {
        return result.filter(function (i) {
            return i !== "";
        });
    } else {
        return result;
    }
};

// export const formatNewItem = (marca, titulo, num, precio, tipo, img, id = undefined, type = "none") => {
export const formatNewItem = (
    marca,
    titulo,
    num,
    precio,
    tipo,
    img,
    id,
    type,
    disableInput = false
) => {
    const compatibleData = formatCompatibleModelData({
        marca: trimStringsInArray(marca),
        // marca: trimStringsInArray(marca),
        titulo: trimStringsInArray(titulo),
        // titulo: trimStringsInArray(titulo),
        num: trimStringsInArray(num, disableInput),
        // num: num
    });
    if (disableInput) {
        compatibleData.forEach((i) => {
            i.Num = "";
        });
    }
    return {
        id: id === undefined ? uuidv4() : id,
        ModelosCompatibles: compatibleData,
        Img: trimStringsInArray(img),
        Tipo: tipo.trim(),
        Precio: type === "edit" ? precio : parseInt(precio, 10),
        // Precio: type === "edit" ? precio : parseInt(precio.trim(), 10),
        DesabilitarNum: disableInput,
    };
};

export const formatJsonData = (data) => {
    const array = [];
    data.forEach((i) => {
        if (i.Marca2 !== undefined) {
            array.push({
                img: i.Img,
                precio: i.Precio,
                tipo: i.Tipo,
                marca: [i.Marca, i.Marca2],
                titulo: [i.Titulo, i.Titulo2],
                num: [i.Num, i.Num2],
            });
        } else {
            array.push({
                img: i.Img,
                precio: i.Precio,
                tipo: i.Tipo,
                marca: [i.Marca],
                titulo: [i.Titulo],
                num: [i.Num],
            });
        }
    });
    array.forEach((i) => {
        agregarDatos(
            formatNewItem(i.marca, i.titulo, i.num, i.precio, i.tipo, i.img),
            "CatalogoFlexores"
        );
    });
};

export const addDisableNum = (items) => {
    items.forEach((i) => {
        i.ModelosCompatibles.forEach((j) => {
            if (j.Num === "") {
                editar({ ...i, DesabilitarNum: true }, "CatalogoFlexores");
            } else {
                editar({ ...i, DesabilitarNum: false }, "CatalogoFlexores");
            }
        });
    });
    // editar()
};

export const formatCompatibleModelData = (data) => {
    if (data.marca !== undefined) {
        const extractIterableItems = [];
        for (var i = 0; i < data.marca.length; i++) {
            extractIterableItems.push({
                Brand: data.marca[i],
            });
            extractIterableItems[i].Brand = data.marca[i];
            extractIterableItems[i].Model = data.titulo[i];
            extractIterableItems[i].Num = data.num[i];
        }
        return extractIterableItems;
    }
};

export const reverseFormatCompatibleData = (data) => {
    const marcas = data.ModelosCompatibles.map((i) => i.Brand);
    const modelos = data.ModelosCompatibles.map((i) => i.Model);
    const nums = data.ModelosCompatibles.map((i) => i.Num);
    return [marcas, modelos, nums];
};

export const formatNewItemWithId = (item) => {
    return {
        id: generateKey(`${item.marca} ${item.titulo} ${item.tipo}`),
        Marca: item.marca,
        Titulo: item.titulo,
        Num: item.num,
        Precio: item.precio,
        Tipo: item.tipo,
        Img: item.img,
    };
};

export const handleSearch = (item, busq) => {
    let concatenatedString = "";
    let search = "";

    busq.forEach((i) => {
        search = search.concat(i, " ");
    });

    const searchWithoutAccents = (removeAccents(search.trim())).split(" ");
    
    item.ModelosCompatibles.forEach((i) => {
        concatenatedString = concatenatedString.concat(
            ` ${i.Brand} ${i.Model} ${i.Num}`
        );
    });
    concatenatedString = `${concatenatedString.trim()} ${item.Tipo}`
        .replace(/ \//g, "")
        .toLowerCase();
    concatenatedString = removeAccents(concatenatedString);
    const result = [];
    searchWithoutAccents.forEach((i) => {
        result.push(concatenatedString.indexOf(i));
    });
    return result.every((i) => i !== -1);
};

const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export function detectTouchScreen(setTouchScreen) {
    if ("ontouchstart" in document.documentElement) {
        setTouchScreen(true);
    } else {
        setTouchScreen(false);
    }
}
